export enum HttpErrorMessages {
  error302Message = "En tjenesten har blitt flyttet middlertidig (302)",
  error400Message = "En valideringsfeil oppsto (400)",
  error401Message = "Du har ikke tilgang (401)",
  error404Message = "Ressursen som ble forespurt finnes ikke (404)",
  errorGeneralMessage = "En systemfeil oppsto. Vi er i gang med å undersøke problemet",
}
